module.exports = __webpack_public_path__ + "static/media/tutorialArrow4.ea6f5ce7.svg";